import { ref as e } from "vue";
import { createI18n as t } from "vue-i18n";
//#region src/plugin/i18n.ts
var n = e([]), r = e(), i = e(), a = e(), o = async (e) => {
	if (!r.value || n.value.includes(e)) return;
	if (!a.value) throw Error("Message loader is not set. Cannot load translations.");
	let t = await a.value(e);
	r.value.global.setLocaleMessage(e, t), n.value.push(e);
}, s = () => r.value?.global.locale, c = () => new URLSearchParams(window.location.search).get("lang") || window.localStorage.getItem("language") || window.navigator.language, l = (e, t) => {
	let n = t.find((t) => t === e);
	if (n) return n;
	let r = e.split("-")[0], i = t.find((e) => e.startsWith(r));
	if (i) return i;
}, u = async (e) => {
	let n = l(c(), e.supportedLocales) || e.locale;
	return i.value = e.application, a.value = e.loadMessages, r.value = t({
		legacy: !1,
		locale: n,
		flatJson: !0,
		missing: e.onMissing ? (t, n) => e.onMissing(t, n) : void 0
	}), await o(n), r.value;
}, d = (e) => (r.value = t({
	legacy: !1,
	locale: e.locale,
	flatJson: !0,
	messages: e.messages
}), i.value = e.application, a.value = async (t) => e.messages[t] ?? {}, r.value), f = {
	Registration: "registration",
	Frontoffice: "frontoffice",
	Admin: "admin",
	Backoffice: "backoffice"
}, p = {
	Dutch: "nl-NL",
	BelgianDutch: "nl-BE",
	French: "fr-FR",
	BelgianFrench: "fr-BE",
	German: "de-DE",
	Spanish: "es-ES",
	Italian: "it-IT",
	BritishEnglish: "en-GB"
};
//#endregion
export { f as Applications, p as Locales, i as application, u as createI18nInstance, d as createTestI18n, s as getCurrentLanguage, r as i18nInstance, o as loadLanguageTranslations, n as loadedLanguages, a as messageLoader };

//# sourceMappingURL=main.js.map